import { createAction, props } from '@ngrx/store';

// Booking actions
export const updateBookingType = createAction(
  '[Booking] Update Booking Type',
  props<{ payload: string }>()
);

export const updateBookingSelectionType = createAction(
  '[Booking] Update Booking Selection Type',
  props<{ payload: boolean }>()
);

export const updateBookingProduct = createAction(
  '[Booking] Update Booking Product',
  props<{ payload: string }>()
);

export const updateBookingPaid = createAction(
  '[Booking] Update Booking Paid',
  props<{ payload: boolean }>()
);

export const updateBookingRequiresPayment = createAction(
  '[Booking] Update Booking Requires Payment',
  props<{ payload: boolean }>()
);

export const updateIsAirportToAirport = createAction(
  '[Booking] Update Is Airport To Airport',
  props<{ payload: boolean }>()
);

export const updateJourneyLeg = createAction(
  '[Booking] Update Journey Leg',
  props<{ payload: any }>()
);

export const updateCarrier = createAction(
  '[Booking] Update Carrier',
  props<{ payload: any }>()
);

export const updateBookingReference = createAction(
  '[Booking] Update Booking Reference',
  props<{ payload: string }>()
);

export const updateBookingJourneyReference = createAction(
  '[Booking] Update Booking Journey Reference',
  props<{ payload: string }>()
);

export const updateBookingAmendSection = createAction(
  '[Booking] Update Booking Amend Section',
  props<{ payload: string }>()
);

export const updateBookingAmendType = createAction(
  '[Booking] Update Booking Amend Type',
  props<{ payload: string }>()
);

export const updateBookingSource = createAction(
  '[Booking] Update Booking Source',
  props<{ payload: string }>()
);

export const updateBookingTimeAmended = createAction(
  '[Booking] Update Booking Time Amended',
  props<{ payload: boolean }>()
);

export const updateBookingAmendPaidInvoice = createAction(
  '[Booking] Update Booking Amend Paid Invoice',
  props<{ payload: boolean }>()
);

export const updateBookingAmendPaymentFailed = createAction(
  '[Booking] Update Booking Amend Payment Failed',
  props<{ payload: boolean }>()
);

export const updateBookingId = createAction(
  '[Booking] Update Booking ID',
  props<{ payload: string }>()
);

export const updateVirtualBags = createAction(
  '[Booking] Update Virtual Bags',
  props<{ payload: number }>()
);

export const updateBagItems = createAction(
  '[Booking] Update Bag Items',
  props<{ payload: any }>()
);

export const updateTotalPrice = createAction(
  '[Booking] Update Total Price',
  props<{ payload: string }>()
);

export const updatePremiumSurcharge = createAction(
  '[Booking] Update Premium Surcharge',
  props<{ payload: any }>()
);

export const updatePlaceId = createAction(
  '[Booking] Update Place ID',
  props<{ payload: string }>()
);

export const updateCustomerAddress = createAction(
  '[Booking] Update Customer Address',
  props<{ payload: any }>()
);

export const updateCustomerDetails = createAction(
  '[Booking] Update Customer Details',
  props<{ payload: any }>()
);

export const updateCustomerHasMarketingEnrolment = createAction(
  '[Booking] Update Customer Has Marketing Enrolment',
  props<{ payload: boolean }>()
);

export const updateCustomerReturnUrl = createAction(
  '[Booking] Update Customer Return URL',
  props<{ payload: string }>()
);

export const updatePnrData = createAction(
  '[Booking] Update PNR Data',
  props<{ payload: any }>()
);

export const updatePromo = createAction(
  '[Booking] Update Promo',
  props<{ payload: any }>()
);

export const removePromo = createAction(
  '[Booking] Remove Promo',
  props<{ payload: any }>()
);

export const updateQuotePriceRequest = createAction(
  '[Booking] Update Quote Price Request',
  props<{ payload: any }>()
);

export const updateQuote = createAction(
  '[Booking] Update Quote',
  props<{ payload: any }>()
);

export const updateAbTestQuote = createAction(
  '[Booking] Update AB Test Quote',
  props<{ payload: any }>()
);

export const updateAbTestForm = createAction(
  '[Booking] Update AB Test Form',
  props<{ payload: any }>()
);

export const updateAddBookingCalled = createAction(
  '[Booking] Update Add Booking Called',
  props<{ payload: boolean }>()
);

export const refreshBookingState = createAction(
  '[Booking] Refresh Booking State',
  props<{ payload: any }>()
);

export const resetBookingState = createAction(
  '[Booking] Reset Booking State'
);

export const hasCustomsAgreement = createAction(
  '[Booking] Has Customs Agreement',
  props<{ payload: boolean }>()
);

export const zoneInfoUpdate = createAction(
  '[Booking] Zone Info Update',
  props<{ payload: any }>()
);

export const updateD2DService = createAction(
  '[Booking] Update D2D Service',
  props<{ payload: boolean }>()
);

export const updateAutoRefreshTimeService = createAction(
  '[Booking] Update Auto Refresh Time Service',
  props<{ payload: any }>()
);

export const saveSelectedTimeslotDateTime = createAction(
  '[Booking] Save Selected Timeslot Date Time',
  props<{ payload: string }>()
);

export const saveUuid = createAction(
  '[Booking] Save UUID',
  props<{ payload: string }>()
);

export const updateSbbPublicTransportDiscountStatus = createAction(
  '[Booking] Update SBB Public Transport Discount Status',
  props<{ payload: boolean }>()
);

export const sbbSubsidyStatusUpdate = createAction(
  '[Booking] SBB Subsidy Status Update',
  props<{ payload: boolean }>()
);

export const updateReservedTimeslot = createAction(
  '[Booking] Update Reserved Timeslot',
  props<{ payload: string }>()
);

export const updateBookingReferenceState = createAction(
  '[Booking] Update Booking Reference State',
  props<{ payload: any }>()
);

export const resetBookingReferenceState = createAction(
  '[Booking] Reset Booking Reference State'
);

export const bookerDataBackup = createAction(
  '[Booking] Booker Data Backup',
  props<{ payload: any }>()
);

export const updateAirportTimeslot = createAction(
  '[Booking] Update Airport Timeslot',
  props<{ payload: { start: string, end: string, date: string } }>()
);

export const updateTimeslot = createAction(
  '[Booking] Update Timeslot',
  props<{ payload: { start: string, end: string, date: string, id: string,airportTimeslotsWarning: boolean, overrideTimeSlotCapacity:boolean } }>()
);

export const updateUniqueSequenceId = createAction(
  '[Booking] Update Unique Sequence ID',
  props<{ payload: string }>()
);
